import React from "react";
import { Helmet } from "react-helmet";
import "../styles/videos.css";
import $ from "jquery";

function vidbtn1() {
  $(".current");
  $(".act-btn").removeClass("act-btn");
  $("#vidbtn1").addClass("act-btn");
  $(".current").removeClass("current").hide();
  $("#music-videos").css("display", "flex").addClass("current");
}

function vidbtn2() {
  $(".act-btn").removeClass("act-btn");
  $("#vidbtn2").addClass("act-btn");
  $(".current").removeClass("current").hide();
  $("#lyric-videos").css("display", "flex").addClass("current");
}

const Videos = () => {
  return (
    <div>
      <Helmet>
        <title>GAUSH - VIDEOS</title>
      </Helmet>
      <section className="video-catalog">
        <p
          style={{
            fontSize: "50px",
            color: "#ffffff",
            lineHeight: "90%",
            marginBottom: "60px",
          }}
        >
          VIDEOS
        </p>
        <div className="vidbtn">
          <img
            onClick={vidbtn1}
            src="/images/music-videos.svg"
            id="vidbtn1"
            className="act-btn"
          />
          <img onClick={vidbtn2} src="/images/lyric-videos.svg" id="vidbtn2" />
        </div>
        <div className="vid-blocks">
          <div id="music-videos" className="current vid-frames">
            <a
              href="https://www.youtube.com/watch?v=InpKfKmxerc"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/InpKfKmxerc/mqdefault.jpg" />
                <p>GAUSH - BLEW UP</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=YvDiFwuRusg"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/YvDiFwuRusg/mqdefault.jpg" />
                <p>GAUSH - OH MY GAUSH</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=jEWUEM7pM5U"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/jEWUEM7pM5U/mqdefault.jpg" />
                <p>GAUSH - I SWEAR</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=EO0b9ByWs_8"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/EO0b9ByWs_8/mqdefault.jpg" />
                <p>GAUSH - LEGENDARY</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=GAIqyjJ1xyg"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/GAIqyjJ1xyg/mqdefault.jpg" />
                <p>GAUSH X FLOWBO - KAUN HAI ?</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=K0dQ-93TmvE"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/K0dQ-93TmvE/mqdefault.jpg" />
                <p>GAUSH - XIX FREEVERSE</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=-yCTbDPjIi0"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/-yCTbDPjIi0/mqdefault.jpg" />
                <p>GAUSH - GOD'S WORK</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=8Vu5Lt3k5Ak"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/8Vu5Lt3k5Ak/mqdefault.jpg" />
                <p>GAUSH x NOTION XIX - KEHDO</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=JruooWBTG1E"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/JruooWBTG1E/mqdefault.jpg" />
                <p>GAUSH - BEETE LAMHE</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=LtCCMOoNQ30"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/LtCCMOoNQ30/mqdefault.jpg" />
                <p>GAUSH - FUTURE SUPERSTAR</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=pNXNHwCZdGA"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/pNXNHwCZdGA/mqdefault.jpg" />
                <p>GAUSH - 22 FREESTYLE</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=f79mLVk2h_w"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/f79mLVk2h_w/mqdefault.jpg" />
                <p>GAUSH - AAKHRI SAAS</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=aCH2fo3YCJ8"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/aCH2fo3YCJ8/mqdefault.jpg" />
                <p>GAUSH - WO KEHTI THI</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=ovKgkX1y7hE"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/ovKgkX1y7hE/mqdefault.jpg" />
                <p>GAUSH - SPIT IT BACK</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=WodAc7BcmYk"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/WodAc7BcmYk/mqdefault.jpg" />
                <p>GAUSH x NOTION XIX - ALRIGHT</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=ys6UgjrbkA0"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/ys6UgjrbkA0/mqdefault.jpg" />
                <p>GAUSH - 21 FREESTYLE</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=CuZpLRoqUFw"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/CuZpLRoqUFw/mqdefault.jpg" />
                <p>GAUSH - SYKOTHERAPY 2</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=hs9ThT6kH8A"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/hs9ThT6kH8A/mqdefault.jpg" />
                <p>GAUSH x NOTION XIX - PHASES</p>
              </div>
            </a>
          </div>
          <div id="lyric-videos" className="vid-frames">
            <a
              href="https://www.youtube.com/watch?v=kJUCYGOQORY"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/kJUCYGOQORY/mqdefault.jpg" />
                <p>GAUSH - ON MY MIND</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=xGDnjw0y79s"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/xGDnjw0y79s/mqdefault.jpg" />
                <p>GAUSH x NOTION XIX - FOREVER ALIVE</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=E6D44E7oKPg"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/E6D44E7oKPg/mqdefault.jpg" />
                <p>GAUSH - ROSHNI</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=ZQ8gJ6lF6qQ"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/ZQ8gJ6lF6qQ/mqdefault.jpg" />
                <p>GAUSH x AAFAT x VELOCT - FLAMETHROWER</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=2cwO5BgOXX4"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/2cwO5BgOXX4/mqdefault.jpg" />
                <p>GAUSH x NOTION XIX - PLATINUM</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=YK1dRljDKg8"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/YK1dRljDKg8/mqdefault.jpg" />
                <p>GAUSH - NA JAANE KYU?</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=-oJFa4DVuJQ"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/-oJFa4DVuJQ/mqdefault.jpg" />
                <p>GAUSH - SO DONE</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=fzqHLejx2SQ"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/fzqHLejx2SQ/mqdefault.jpg" />
                <p>GAUSH x PANADOL - WE STAY HIGH</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=UCX_WHHOVes"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/UCX_WHHOVes/mqdefault.jpg" />
                <p>GAUSH x NOTION XIX - FACE OFF</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=CmzpI_4-6ao"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/CmzpI_4-6ao/mqdefault.jpg" />
                <p>GAUSH - EPIPHANY</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=9xCCbuUpJrQ"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/9xCCbuUpJrQ/mqdefault.jpg" />
                <p>GAUSH - RUN | SIKANDER KAHLON RANN REMIX</p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=YBR3oRk-eQ0"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/YBR3oRk-eQ0/maxresdefault.jpg" />
                <p>
                  GAUSH - SOBER GANG FLOW (Ft. JAGZ, NOTION XIX) | SEEDHE MAUT
                  KRANTI REMIX
                </p>
              </div>
            </a>
            <a
              href="https://www.youtube.com/watch?v=ovg4p7sDhbg"
              style={{ textDecoration: "none" }}
              target="_blank"
            >
              <div>
                <img src="https://img.youtube.com/vi/ovg4p7sDhbg/mqdefault.jpg" />
                <p>GAUSH - ASTAGHFIRULLAH REMIX | MC ST∆N</p>
              </div>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Videos;
